import { Link as ScrollLink } from 'react-scroll';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

import back from "../assets/icons/back-arrow.png"
import logo from '../moodmealslogo.png';
import facebook from "../assets/icons/Facebook.png";
import instagram from "../assets/icons/Instagram.png";
import twitter from "../assets/icons/TwitterX.png";

import '../styles/QuizPage.css';

const Quizpage=()=>{

    const [isLoading,setIsLoading]=useState(true);
    
    useEffect(()=>{
        setTimeout(()=>{
          setIsLoading(false);
        },2000);
    },[]);

    const questions=[{
        question:"How are you feeling today?",
        answers:[
            {text:"Comfort",emoji:"😊"},
            {text:"Relieved",emoji:"😌"},
            {text:"Focused",emoji:"🤔"},
            {text:"Energized",emoji:"😃"},
        ]},{
        question:"What type of meal are you craving?",
        answers:[
            {text:"Comfort Food",emoji:"🍔"},
            {text:"Healthy",emoji:"🥗"},
            {text:"Quick Snack",emoji:"🍪"},
            {text:"Gourmet",emoji:"🍣"},
        ]},{
        question:"What time of day do you feel your best?",
        answers:[
            {text:"Morning",emoji:"🌞"},
            {text:"Afternoon",emoji:"☁️"},
            {text:"Evening",emoji:"🌙"},
            {text:"It varies",emoji:"💡"},
        ]},{
        question:"What type of meal would make you feel your best right now?",
        answers:[
            {text:"A meal with calming ingredients like chamomile, oats, or sweet potatoes."},
            {text:"Something with high-energy foods like quinoa, salmon, or leafy greens."},
            {text:"A brain-boosting meal with nuts, berries, and lean proteins."},
            {text:"Comfort food like pasta, mashed potatoes, or a warm casserole."},
        ]},{
        question:"Which flavor profile are you craving right now?",
        answers:[
            {text:"Sweet and soothing, like honey or vanilla."},
            {text:"Fresh and zesty, like citrus or herbs."},
            {text:"Savory and bold, like garlic or ginger."},
            {text:"Rich and comforting, like cheese or creamy dishes."},
        ]},{
        question: "What do you usually drink to complement your meals?",
        answers:[
            {text:"Herbal teas or warm beverages."},
            {text:"Smoothies or fresh juices."},
            {text:"Coffee or brain-boosting drinks like matcha."},
            {text:"Water or rich hot chocolate to satisfy cravings."},
        ]},{
        question:"What’s your priority when choosing a meal?",
        answers:[
            {text:"Something that helps me unwind and de-stress."},
            {text:"Something that boosts my energy and keeps me going."},
            {text:"Something that keeps me focused and productive."},
            {text:"Something that gives me comfort and feels like a warm hug."},
        ]},
    ]

    const [quizStarted,setQuizStarted]=useState(false);
    const [currentQuestion,setCurrentQuestion]=useState(0);
    const [answers,setAnswers]=useState([]);
    const [showCongratulatoryText,setShowCongratulatoryText]=useState(false);

    const StartQuiz=()=>{
        setQuizStarted(true)
    }

    const AnswerClick=(answer)=>{
        setAnswers([...answers,answer])
        setShowCongratulatoryText(true);
        setTimeout(()=>{
            setShowCongratulatoryText(false);
            if(currentQuestion<questions.length-1) {
              setCurrentQuestion(currentQuestion+1);
            }else{
              // Handle quiz completion (e.g., show results)
              console.log("Quiz completed",answers);
            }
        },2000);
    }

    const progress=((currentQuestion+1)/questions.length)*100;

    return(
        <>
            {isLoading?(
                <div className="loadingContainer">
                    <img src={logo} alt="Loading..." className="moodmeals-loading-logo"/>
                </div>
            ):(
            <>
                <div className="quiz-bg-icon">
                    <div className="quiz-flex"> 
                        <header className="quiz-header">
                            <div className="quiz-back">
                                <Link to="/"><img src={back} className="quiz-back-btn" alt="Back"/> Back</Link>
                            </div>
                            <div className="quiz-moodmeals-logo">
                                <img src={logo} alt="logo"/>
                            </div>
                        </header>
                        <div className="quiz-wrapper">
                            {!showCongratulatoryText?(
                                <div className="quiz-title">
                                    <h1>What’s Your Mood?</h1>
                                    <p>Find the Perfect Meal for You!</p>
                                </div>
                            ):(
                                showCongratulatoryText && (
                                    <div className="congratulatory-text">Great choice! Almost there!</div>
                                )
                            )}
                            <div className="mood-quiz">
                                {!quizStarted ? (
                                    <div className="mood-quiz-container">
                                        <div className="quiz-description">
                                            <p>Whether you’re feeling stressed, tired, or just need a pick-me-up, MoodMeals has the perfect meal for you. Answer a few quick questions to get personalized meal recommendations tailored to your emotions!</p>
                                        </div>
                                        <div className="quiz-emojis-container">
                                            <div className="quiz-emojis">
                                                <span className="quiz-emoji" role="img" aria-label="comfort">😊</span>
                                                <span className="quiz-emoji" role="img" aria-label="relieved">😌</span>
                                                <span className="quiz-emoji" role="img" aria-label="focus">🤔</span>
                                                <span className="quiz-emoji" role="img" aria-label="energize">😃</span>
                                            </div>
                                        </div>
                                        <button className="quiz-button" onClick={StartQuiz}>{'> > > >'} Let's Begin {'< < < <'}</button>
                                    </div>
                                ):(
                                    <div className="quiz-section">
                                        <div className="quiz-progress-bar">
                                            <div className="quiz-progress" style={{width:`${progress}%`}}>
                                                Question {currentQuestion+1} of {questions.length}
                                            </div>
                                        </div>
                                        <div className="quiz-question">
                                            <h2>{questions[currentQuestion].question}</h2>
                                            <div className="quiz-answers">
                                                {questions[currentQuestion].answers.map((element,index) => (
                                                    <button key={index} className="quiz-answer" onClick={()=>AnswerClick(element)}>
                                                        <span className="quiz-emoji" role="img" aria-label={element.text}>{element.emoji}</span>
                                                        {element.text}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Footer Section --> */}
                <footer className="quiz-footer">
                    <h3 className="quiz-get-in-touch">Get in Touch</h3>
                    <div className="quiz-footer-content">
                        <div className="quiz-footer-section">
                            <h3>Customer Support</h3>
                            <p>Email: <a href="/">support@moodmeals.com</a></p>
                            <p>Phone: <a href="/">+63 (800) 123-4567</a></p>
                            <p>Live Chat: Available Monday to Friday, 9 AM - 6 PM (EST)</p>
                            <h3>General Inquiries:</h3>
                            <p>For general questions, feedback, or press inquiries, please email: <a href="/">info@moodmeals.com</a></p>
                            <h3>Partnership Opportunities:</h3>
                            <p>Interested in partnering with MoodMeals? Reach out to: <a href="/">partnerships@moodmeals.com</a></p>
                        </div>
                        <div className="quiz-footer-section">
                            <h3>Quick Links</h3>
                            <ul>
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/shop">Shop</Link></li>
                                <li><Link to={{pathname:"/",state:{section:"recipes"}}}>Recipes</Link></li>
                                <li><Link to={{pathname:"/",state:{section:"community"}}}>Community</Link></li>
                                <li><Link to={{pathname:"/",state:{section:"about-us"}}}>About Us</Link></li>
                                <li><ScrollLink to="contact" smooth={true} duration={500}>Contact</ScrollLink></li>
                                <li><Link to={{pathname:"/",state:{Element:"blog"}}}>Blog</Link></li>
                            </ul>
                        </div>
                        <div className="quiz-footer-section">
                            <h3>Customer Services</h3>
                            <ul>
                                <li><a href="#contact-us">Contact Us</a></li>
                                <li><a href="#faq">FAQ</a></li>
                                <li><a href="#shipping&returns">Shipping & Returns</a></li>
                                <li><a href="#terms&condition">Terms & Condition</a></li>
                                <li><a href="#privacy">Privacy Policy</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="quiz-soc-med">
                        <div className="quiz-app-wrapper">
                            <img className="app" src={facebook} alt="facebook"/>
                            <img className="app" src={instagram} alt="instagram"/>
                            <img className="app" src={twitter} alt="twitter"/>
                            <p>Mailing Address: MoodMeals HQ 123 Wellness Lane, Healthy City, MA 10001, Philippines</p>
                        </div>
                        <div className="quiz-copyright">
                            <p>&copy; 2024 MoodMeals. All rights reserved.</p>
                        </div>
                    </div>
                </footer>
            </>
            )}
        </>
    )

}

export default Quizpage;